import { RouteRecordRaw, RouterView } from "vue-router";
const routes: RouteRecordRaw = {
  path: "stuInformation",
  name: "stuInformation",
  component: () => import("@/views/student-information/index.vue"),
};
export default routes;
